import { setupInterceptors } from '@/services/setupInterceptors'
import store from '../store'

setupInterceptors(store)